import React from "react";
import Store from "./Store";
import { Helmet } from "react-helmet";
import StoryContainer from "./container/StoryContainer";
import "./App.scss";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import ReactGA from "react-ga4";
import { getCountryFromUrl } from "./utils/helpers";
import PlayerPage from "./components/PlayerPage";
import CopyLinkContainer from "./components/CopyLinkContainer/CopyLinkContainer";

import { openLightbox, updateLightbox, handleHover, updatePreview } from "./utils/storyUIHandlers";

ReactGA.initialize("G-9R3S0492XE");
let country = getCountryFromUrl();

function App() {
  return (
    <Store className="App">
      <Helmet>
        <meta name="robots" content="noindex"></meta>
        <script type="text/javascript" src="//script.crazyegg.com/pages/scripts/0130/4183.js" async="async"></script>
      </Helmet>
      <Router>
        <Switch>
          {/* <Route path="/:guid/player/:id" exact>
            <PlayerPage />
          </Route> */}
          <Route path="/:guid" exact>
            <StoryContainer />
          </Route>
        </Switch>
        <CopyLinkContainer mount={updatePreview} callbackHandler={openLightbox} updateLightbox={updateLightbox} />
      </Router>
    </Store>
  );
}

export default App;
